/* user roles have to match with backend roles */
export enum UserRoles {
  manaMember = 'Member',
  manaVendor = 'ManaVendor',
  manaInvest = 'InvestMana',
  vendor = 'VendorOutside',
  manaPartner = 'PartnerMana',
}
